import { createStore } from 'vuex'

const store = createStore({
  state: {
    firstName: 'Daniel',
    surName: 'Effiong',
    email: 'danroyaleffiong@gmail.com',
    isDarkTheme: false
  },
  mutations: {
    setDarkTheme(state, isDarkTheme: boolean){
      state.isDarkTheme = isDarkTheme;
    }
  },
  actions: {
  },
  modules: {
  }
});

export default store;
